// src/components/roles/RolesTable/RolesTable.styles.ts
import { Box, Chip, Typography } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

/**
 * Badge para mostrar número de usuarios
 */
export const UsersBadge = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  padding: theme.spacing(0.5, 1),
  borderRadius: theme.spacing(1.5),
  backgroundColor: alpha(theme.palette.info.main, theme.palette.mode === 'dark' ? 0.22 : 0.18),
  color: theme.palette.mode === 'dark' ? theme.palette.info.light : theme.palette.info.dark,
  fontWeight: 600,
  fontSize: '0.875rem',
  '& .MuiSvgIcon-root': {
    fontSize: '1rem',
  },
}));

/**
 * Badge para roles del sistema
 */
export const SystemBadge = styled(Chip)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? alpha(theme.palette.common.white, 0.12)
      : theme.palette.grey[200],
  color: theme.palette.text.secondary,
  fontSize: '0.75rem',
  fontWeight: 500,
  height: 20,
  '& .MuiChip-label': {
    padding: theme.spacing(0, 0.75),
  },
}));

/**
 * Nombre del rol (Bold 600, text.primary)
 */
export const RoleName = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
  fontSize: '1rem',
  letterSpacing: 0.2,
}));

/**
 * Descripción del rol (text.secondary, truncado)
 */
export const RoleDescription = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: theme.palette.text.secondary,
  fontSize: '0.95rem',
  maxWidth: '400px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

/**
 * Contenedor de acciones
 */
export const ActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: theme.spacing(0.5),
}));

/**
 * Container para loading state
 */
export const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(8),
}));
